export const isOmnisendCartActive = process.env.NEXT_PUBLIC_OMNISEND_CART_ACTIVE === 'true';
export const CART_RECOVERY_PARAM = 'cartRecoveryID';
